import { getLegalApi } from './legal-api';
import { get } from 'lodash-es';
import { create } from '@eureka/utils/deferred'

const deferred = create();

getLegalApi().then(res => {
    deferred.resolve(res)
})

export async function useLegalStatus(code?: number|string, lang = 'en') {
    const { simpleLegalStatus } = await deferred.promise
    if (code === undefined || code === null) return
    const currentLegalInfo = get(simpleLegalStatus, code)
    if (!currentLegalInfo) return;
    return {
        color: currentLegalInfo.color,
        text: get(currentLegalInfo.title, lang) as string,
    };
}
